export const CURRENCY_DECIMAL_PLACES = 2;
export const LIMIT_FOR_RENDERING_TRILLIONS = 1000000000000;
export const LIMIT_FOR_RENDERING_BILLIONS = 1000000000;
export const LIMIT_FOR_RENDERING_MILLIONS = 1000000;
export const LIMIT_FOR_RENDERING_THOUSANDS = 1000;

export const INTL_NUMBER_REGEX = /[\d.,]+/;
export const OTHER_DOLLAR_SIGNS = /(A\$|NZ\$)/;

export const DEFAULT_CURRENCY_SYMBOL = '£';
export const DEFAULT_LOCALE_CODE = 'en-GB';
export const LOCALE_CHANGE_EVENT = 'localeChange';
export const LOCALE_STORAGE_KEY = 'userLocale';
export const SUPPORTED_LOCALE_CODES = ['en-GB', 'fr-FR', 'fr-CA', 'en-test1', 'en-test2'] as const;
